import PropTypes from 'prop-types';
import React from 'react';

import LegalText from '../components/LegalText'

function AppFooter(props) {

    return (
        <div className="footer-wrapper">
            <footer className={"footer"}>
                <h4>Allgemein</h4>
                <div className={"separator"}/>
                <ul className={"floating-menu"}>
                    <li><a href="https://www.mittwald.de/kontakt-impressum" rel="noreferrer">Impressum</a></li>
                    <li><a href="https://www.mittwald.de/agb" rel="noreferrer">AGB</a></li>
                    <li><a href="https://www.mittwald.de/datenschutz" rel="noreferrer">Datenschutz</a></li>
                </ul>
                <div className={"footer__bottom"}>
                    <LegalText className="footer__bottom__legal"/>
                    <div className="logo">
                        <a href="http://mittwald.de"><img role="presentation" src="images/mw_icon_white.svg"/></a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

AppFooter.propTypes = {
    columnWidth: PropTypes.string,
    showLegalText: PropTypes.bool
};

export default AppFooter



/** WEBPACK FOOTER **
 ** ./src/components/AppFooter.js
 **/